import { render, staticRenderFns } from "./partnerForm.vue?vue&type=template&id=3290585d&scoped=true&"
import script from "./partnerForm.vue?vue&type=script&lang=js&"
export * from "./partnerForm.vue?vue&type=script&lang=js&"
import style0 from "./partnerForm.scss?vue&type=style&index=0&id=3290585d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3290585d",
  null
  
)

export default component.exports